import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { media } from '../helpers';

const CollectionBannerContainer = styled.section`
    position: relative;

    .title-container {
        position: absolute;
        left: auto;
        margin: 0 20px;
        top: 35%;

        ${media.medium`left: 10vw; margin: 0; top: 40%;`}

        .inner-wrap {
            background-color: #f2f0eb;
            padding: 35px;
            max-width: 450px;

            h1 {
                margin: 0 0 10px;
                font-size: 3rem;
                color: #0f1212;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
            }

            p {
                font-size: 1.1rem;
                line-height: 1.5;
                margin-bottom: 0px;
            }
        }
    }
    .gatsby-image-wrapper {
        min-height: 45vh;
    }
`;

const CollectionBanner = ({ image, title, caption }) => {
    return (
        <CollectionBannerContainer>
            <Img fluid={image} alt={title + ' banner image'} />
            <div className="title-container">
                <div className="inner-wrap">
                    <h1>{title}</h1>
                    {caption && <p>{caption}</p>}
                </div>
            </div>
        </CollectionBannerContainer>
    );
};

export default CollectionBanner;
